import common from './common'

export default {
  ...common.button,
  color: `white`,
  bg: `omegaDark`,
  borderColor: `omegaDark`,
  ':hover': {
    bg: `alpha`,
    color: `white`,
    borderColor: `alpha`
  }
}
